export const en = {
  pages: {
    confirmationNeeded: "Confirmation Needed",
    checkoutRecovery: "Checkout Recovery",
    openDraftOrders: "Open Draft Orders",
    mySnoozed: "My Snoozed",
    myArchived: "My Archived",
    unassigned: "Unassigned",
    needsAttention: "Needs Attention",
  },
  disable: {
    title: "Disable {{name}}?",
    description: "This trigger will be disabled. All previous activities will remain visible, but from this point forward, no new activities will be synced from the customer store.",
    disabling: "Disabling...",
    confirm: "Yes, Disable Trigger",
  },
  history: {
    action: { enabled: "Turned On", disabled: "Turned Off", updated: "Changed" },
    value: { nothing: "Nothing", on: "On", off: "Off" },
    changesCount_one: "{{count}} change",
    changesCount_other: "{{count}} changes",
    empty: {
      title: "No activity yet",
      description: "When rules are turned on, changed, or turned off, the details will show up here.",
    },
    filters: {
      activityAll: "All",
      activityLabel: "Activity",
      ruleAll: "All Rules",
      ruleLabel: "Rule",
    },
    fields: {
      enabled: "Status",
      sync_tag: "Sync Tag",
      conditions: {
        payment_method: "Payment Methods",
        min_order_value: "Minimum Order Value",
        include_tags: "Include Tags",
        exclude_tags: "Exclude Tags",
        order_source: "Order Source",
        min_draft_age_hours: "Minimum Draft Age",
        min_draft_value: "Minimum Draft Value",
        require_phone: "Require Phone",
        min_checkout_value: "Minimum Checkout Value",
        include_customer_tags: "Include Customer Tags",
        exclude_customer_tags: "Exclude Customer Tags",
        checkout_source: "Checkout Source",
        customer_entered_phone: "Customer Entered Phone",
        checkout_step_reached: "Checkout Step Reached",
        returning_customer_only: "Returning Customer Only",
      },
      assignment: {
        team_id: "Team",
        default_owner_id: "Assign to",
        priority: "Priority",
      },
    },
  },
  onboarding: {
    title: "Setup guide",
    dismissAriaLabel: "Dismiss setup guide",
    loadingProgress: "Loading setup progress...",
    tasksCompleted: "{{completed}} of {{total}} tasks completed",
    description: "Complete these steps to get OrderHub ready for your team.",
    goToSetup: "Go to setup",
    finishing: "Finishing...",
    finishSetup: "Finish setup",
    steps: {
      "connect-shopify": {
        title: "Connect Shopify",
        description: "Link your Shopify store and authorize data sync.",
      },
      "configure-triggers": {
        title: "Configure Triggers",
        description: "Setup confirmation needed, open draft orders, and checkout recovery.",
      },
      "invite-users": {
        title: "Invite Your Team",
        description: "Add team members to collaborate on orders.",
      },
    },
  },
  help: {
    backToBilling: "← Back to Billing",
    title: "Contact Us",
    subtitle: "Need more than 15 users or have a billing question? Send us a message and we'll get back to you.",
    success: {
      heading: "Message Sent!",
      body: "Thank you for reaching out. Our team will get back to you within 24 hours.",
      sendAnother: "Send Another Message",
    },
    form: {
      namePlaceholder: "Your name",
      emailPlaceholder: "you@example.com",
      subjectLabel: "Subject",
      subjectPlaceholderOption: "Select a subject",
      subjectEnterprise: "Enterprise Plan (15+ users)",
      subjectBilling: "Billing Question",
      subjectUpgrade: "Plan Upgrade Help",
      subjectOther: "Other",
      messageLabel: "Message",
      messagePlaceholder: "Tell us how we can help...",
      sendButton: "Send Message",
      placeholderNotice: "This is a placeholder form. HelpScout integration will be added soon.",
    },
  },
  userLimitBanner: {
    message: "Your workspace has {{current}} active user(s) but your plan allows {{limit}}. Plan downgrades are blocked until excess users are removed. Excess users will be deactivated if billing lapses.",
    manageUsers: "Manage Users",
  },
  featureGate: {
    upgradePrompt: "Upgrade to {{plan}} plan to unlock {{feature}}",
  },
  names: {
    confirmation_needed: "Confirmation Needed",
    open_draft_orders: "Open Draft Orders",
    checkout_recovery: "Checkout Recovery",
  },
  descriptions: {
    confirmation_needed: "Trigger when a COD or specific-payment-method order requires phone confirmation",
    open_draft_orders: "Trigger when a draft order remains open beyond a time threshold",
    checkout_recovery: "Trigger when an abandoned checkout meets value and phone criteria",
  },
} as const;
